<template>
  <div class="page_bg">
    <!-- 顶部搜索 -->
    <div class="classify_top flex-r-s-c" style="font-size: 0.48rem;">
      <van-icon name="arrow-left" style="margin-left:0.46rem;" @click="backPath" />
      <van-search ref="searchVal" v-model="serValue" class="classify_ser" style="width:8.91rem" placeholder="请输入搜索关键词"
                  shape="round" @search="onSearch" @focus="onFocus" @input="inputWord"
      />
      <div class="classify_btn flex-r-c-c" @click="onSearch(0)">
        <van-button round color="#0767AB" size="small">搜索</van-button>
      </div>
      <div class="classify_kefu flex-r-c-c" />
    </div>
    <!-- 展示搜索页面 -->
    <div v-if="showMore" class="show_ser_more">
      <div v-for="(more,more_index) in wordList" :key="more_index" class="word_item flex-c-c-c">
        <div class="word_box flex-r-s-s" @click="inputSerWord(more)">
          <van-icon name="search" size="0.5rem" />
          <div class="word van-ellipsis"
               v-html="parseInt(more.type) === 2 ? more.proName : more.searchTagNameHighLight"
          />
        </div>
        <div class="diver_word" />
      </div>
    </div>
    <div v-else style="padding-bottom:2rem">
      <div v-show="isSer">
        <MyscrollList ref="myList01" :list="proList" empty-msg="额，被你难到了,换个关键词试试吧" :is-btn="true"
                      jumpurl="/product/addProduct" @myload="proload"
        >
          <template #default="slotProps">
            <proCard01 :info="slotProps.item" />
          </template>
        </MyscrollList>
      </div>
      <div v-show="proList.length===0">
        <!-- 历史查询 -->
        <div v-if="historyList.length>0" class="search_history">
          <div class="search_history_top flex-r-sb-c">
            <div class="history_top_name">搜索历史</div>
            <div class="history_top_icon" @click="clearHistory">
              <van-icon name="delete-o" />
            </div>
          </div>
          <div class="history_contant flex-r-s-s">
            <div v-for="(his,his_index) in historyList" :key="his_index" @click="HSearch(his)">
              <div class="history_message van-ellipsis">{{ his }}</div>
            </div>
          </div>
        </div>
        <!-- 热门搜索 -->
        <div class="search_hot">
          <div class="search_hot_title">热门搜索</div>
          <van-row>
            <div class="search_hot_contant flex-r-s-s" style="flex-wrap: wrap;">
              <van-col v-for="(hot,hot_index) in hotList" :key="hot_index" :span="12">
                <div class="hot_item flex-r-s-c van-ellipsis" @click="toSearch(hot)">
                  <div v-if="hot_index === 0" class="hot_index hot_index_1">{{ hot_index+1 }}</div>
                  <div v-if="hot_index === 1" class="hot_index hot_index_2">{{ hot_index+1 }}</div>
                  <div v-if="hot_index === 2" class="hot_index hot_index_3">{{ hot_index+1 }}</div>
                  <div v-if="hot_index > 2" class="hot_index">{{ hot_index+1 }}</div>
                  <div class="hot_msg">
                    <span v-if="hot.radio === 0">{{ hot.search1 }}</span>
                    <span v-if="hot.radio === 1">{{ hot.search2 }}</span>
                  </div>
                </div>
              </van-col>
            </div>
          </van-row>
        </div>
      </div>
    </div>
    <!-- 购物车 -->
    <div v-if="isSer" class="cart_bottom2">
      <div class="cart_bottom_icon" @click="toCartPath">
        <van-image width="1.6rem" height="1.6rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/cart_icon.png"
        />
        <div v-if="$store.getters.totalShopping > 0" class="badge_box">{{ $store.getters.totalShopping }}</div>
      </div>
      <div class="cart_bottom_info flex-r-c-c" style="height:1.83rem">
        <div class="info_total">
          <span style="font-size: 0.32rem;color: #333;font-weight: 400;">合计：</span>
          <span style="font-size: 0.32rem;">￥</span><span>{{ $store.getters.totalShoppingMoney }}</span>
        </div>
        <div class="info_button" @click="toCartPath">去购物车</div>
      </div>
    </div>
    <!-- loading遮罩层 -->
    <!-- <van-overlay :show="overlayShow" @click="overlayShow = false">
      <div class="overlay_loading">
        <van-loading color="#eee" size="0.6rem" type="spinner" vertical>数据正在赶来的路上...</van-loading>
      </div>
    </van-overlay> -->

  </div>
</template>

<script>
import './index.scss'
import { mallProduct_hotSearch, apiWholesaleProduct_productList, searchTagList } from '@/api/pro'
import MyscrollList from '@/components/MyscrollList'
import proCard01 from '@/components/pro_card_01'
export default {
  components: { MyscrollList, proCard01 },
  data() {
    return {
      serValue: '',
      isSer: false,
      searchForm: { page: 1, limit: 10, name: '' },
      tabIndex: 1,
      historyList: JSON.parse(localStorage.getItem('historySer')) || [],
      hotList: [],
      proList: [],
      listLoading: false,
      overlayShow: false,

      showMore: false,
      wordList: []
    }
  },
  mounted() {
    this.$utils.cartNum(this.$store)
    this.$nextTick(() => {
      // 使用$nextTick或setTimeout处理触发弹框自动获取焦点延迟的问题
      this.$refs.searchVal.querySelector('input').focus()
    })
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    this.$utils.cartNum(this.$store)
    if (this.$route.query.name) {
      this.serValue = this.$route.query.name
      this.searchForm.name = this.$route.query.name
      this.onSearch()
    }
    this.loadHot()
  },
  methods: {
    backPath() { window.history.back() },
    toCartPath() { this.$router.push('/cart/cart') },
    changeType(type) {
      this.tabIndex = type
    },
    // 清空搜索历史
    clearHistory() {
      this.$dialog.confirm({ message: '是否清空历史查询记录' })
        .then(() => {
          localStorage.removeItem('historySer')
          this.historyList = []
        })
        .catch(() => { })
    },
    // 加载热门搜索
    loadHot() { mallProduct_hotSearch().then(res => { this.hotList = res.data }) },
    // 热门、历史查询
    HSearch(val) {
      // this.overlayShow = true
      this.$refs.myList01.load_status_clear()
      this.serValue = val
      this.searchForm.page = 1
      this.searchForm.name = val
      this.proList = []
      this.onSearch(1)
    },
    // 热词搜索
    toSearch(hot) {
      var val = ''
      if (hot.radio === 0) { val = hot.search1 }
      if (hot.radio === 1) { val = hot.search2 }
      this.$refs.myList01.load_status_clear()
      this.serValue = val
      this.searchForm.page = 1
      this.searchForm.name = val
      this.proList = []
      this.onSearch(1)
    },
    // 存localstrong 事件
    setHistory(e) {
      for (var i = 0; i < this.historyList.length; i++) {
        if (this.historyList[i] === e) { this.historyList.splice(i, 1) }
      }
      this.historyList.unshift(e)
      localStorage.setItem('historySer', JSON.stringify(this.historyList))
    },
    // 获焦事件
    onFocus() {
      this.$refs.myList01.load_status_clear()
      this.isSer = false
      this.proList = []
      this.searchForm.page = 1
      this.searchForm.name = ''
      this.searchForm.searchTagId = ''
      // this.serValue = ''
      if (this.$route.query.name) {
        this.searchForm.name = this.$route.query.name
      }
    },
    // 查询事件
    onSearch(type) {
      if (type !== 1) this.searchForm.name = this.serValue
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      this.showMore = false
      apiWholesaleProduct_productList(this.searchForm).then(res => {
        this.$toast.clear()
        // this.overlayShow = false
        this.isSer = true
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        // 存localstrong
        if (this.searchForm.page === 1) { this.setHistory(this.serValue) }
        if (this.searchForm.page === 1 && res.data.list.length === 0) {
          this.$refs.myList01.load_empty('ser', true)
        } else {
          if (res.data.list.length < 10) { // 数据全部加载完成
            if (res.data.list.length > 0) {
              this.$refs.myList01.load_finished(true)
            }
          }
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.searchForm.page = this.searchForm.page + 1
        this.onSearch(1)
        // 加载状态结束
      }, 50)()
    },
    inputSerWord(item) {
      const val = parseInt(item.type) === 2 ? item.proName : item.searchTagName
      this.setHistory(val)
      this.searchForm.page = 1
      this.searchForm.name = parseInt(item.type) === 2 ? item.proName : ''
      this.searchForm.searchTagId = parseInt(item.type) === 2 ? '' : item.searchTagId
      this.serValue = val
      this.proList = []
      this.showMore = false
      this.onSearch(1)
    },
    inputWord(e) {
      console.log('inputWord', e)
      if (e.length >= 2) {
        searchTagList({ page: 1, limit: 999, keyWords: e }).then(res => { this.wordList = res.data.list })
        this.showMore = true
      } else { this.wordList = []; this.showMore = false }
    }
  }
}
</script>

<style lang="scss">
body {
  background: #f7f7f7;
}
</style>
